import { observer } from 'mobx-react-lite';

import { Logo } from '../Logo';

import type { ComponentProps } from 'react';

export interface CoBrandingLogoProps extends ComponentProps<typeof Logo> {
	readonly logoUrl: string;
}

export const CoBrandingLogo = observer(function CoBrandingLogo({ logoUrl, ...props }: CoBrandingLogoProps) {
	if (!logoUrl) {
		throw new Error('CoBrandingLogo requires a non-empty logoUrl');
	}

	return (
		<Logo
			{...{
				...props,
				children: <img {...{ src: logoUrl, alt: 'Organization logo' }} />,
			}}
		/>
	);
});
